module.exports = __webpack_public_path__ + "img/13.05309071.png";